import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

export const store=new Vuex.Store({
  state:{
    drawer:null,
     application_form_data:{
      admission_form_no:'',
      admission_form_id:''
    },
    notification:null,
    form_progress:0,
    quick_links:false,
    calendar_flag:false,
    today_events:false,
    form_fees_trans_id:null,
    //fees
    data_for_fees:{
      grno_or_app_form_no:null,
      fees_type:null,
      gr_form:null, //GRNO or FORM
      ay:null
    },
    divoff_id:null,
    ldiv_id:null,
    edit_date:null,
    edit_date_new:null,
    lid:null,
    cay_id:null,
    ay:null,
    sem:null,
    reg_no:null,
    coff_id:null,
    crs_off_inst_id:null,

    //receipt
    receipt_id:null, 
    receipt_data:null, //used by vrushali in edit receipt
    role_type:null,//for dashboard
    //commn_id:null,
    
    //below 4 vars used for Homework added on 19-10-21
    ay_id : null,
    coaid : null,
    coi_id : null,
    course_off_id : null,
    div_off_id : null,
    homework_id : null,
    ///video
    vdo_files:[],
    //child data
    child_data:null
  },
  mutations: {
    getformdata(state, application_form_data) {
      state.application_form_data = application_form_data
    },
    setform_progress(state, form_progress) {
      state.form_progress = form_progress
    },
    setquick_links(state,quick_links){
      state.quick_links = quick_links
    },
    setcalendar_flag(state,calendar_flag){
      state.calendar_flag = calendar_flag
    },
    settoday_events(state,today_events){
      state.today_events = today_events
    },
    setform_fees_trans_id(state,form_fees_trans_id){
      state.form_fees_trans_id = form_fees_trans_id
    },
    setdata_for_fees(state,data_for_fees){
      state.data_for_fees = data_for_fees
    },
    setdivoff_id(state,divoff_id){
      state.divoff_id = divoff_id
    },
    setldiv_id(state,ldiv_id){
      state.ldiv_id = ldiv_id
    },
    setedit_date(state,edit_date){
      state.edit_date = edit_date},
    
    setedit_date_new(state,edit_date_new){
      state.edit_date_new = edit_date_new},

    setreceipt_id(state,receipt_id){
      state.receipt_id = receipt_id
    },
    setreceipt_data(state,receipt_data){
      state.receipt_data = receipt_data
    },
    setrole_type(state,role_type){
      state.role_type = role_type
    },
    setlid(state,lid){
      state.lid = lid
    },
    setcay_id(state, cay_id) {
      state.cay_id = cay_id
    },
    //commn_id
    // setcommn_id(state,commn_id){
    //   state.commn_id = commn_id
    // },
    setay(state,ay){
      state.ay = ay
    },
    setsem(state,sem){
      state.sem = sem
    },
    setreg_no(state,reg_no){
      state.reg_no = reg_no
    },
    setcoff_id(state,coff_id){
      state.coff_id = coff_id
    },
    setcrs_off_inst_id(state,crs_off_inst_id){
      state.crs_off_inst_id = crs_off_inst_id
    },

    //below 4 vars used for Homework added on 19-10-21
    setcoaid(state,coaid){
      state.coaid = coaid
    },
    setcourse_off_id(state,course_off_id){
      state.course_off_id = course_off_id
    },
    setay_id(state,ay_id){
      state.ay_id = ay_id
    },
    setdiv_off_id(state,div_off_id){
      state.div_off_id = div_off_id
    },
    setcoi_id(state,coi_id){
      state.coi_id = coi_id
    },
    sethomework_id(state,homework_id){
      state.homework_id = homework_id
    },
    setnotification(state,notification){
      state.notification = notification
    },
    setvdo_files(state,vdo_files){
      state.vdo_files = vdo_files
    },
    setchild_data(state, child_data) {
      state.child_data = child_data
    },
  },
  getters: {
    notification: state => state.notification,
    application_form_data: state => state.application_form_data,
    form_progress: state => state.form_progress,
    quick_links: state => state.quick_links,
    calendar_flag: state => state.calendar_flag,
    today_events: state => state.today_events,
    
    form_fees_trans_id: state => state.form_fees_trans_id,
    data_for_fees: state => state.data_for_fees,
    divoff_id: state => state.divoff_id,
    ldiv_id: state => state.ldiv_id,
    edit_date: state => state.edit_date,
    edit_date_new: state => state.edit_date_new,
    receipt_id: state => state.receipt_id,
    receipt_data: state => state.receipt_data,
    role_type: state => state.role_type,
    lid: state => state.lid,
    cay_id: state => state.cay_id,
    ay: state => state.ay,
    sem: state => state.sem,
    reg_no: state => state.reg_no,
    coff_id: state => state.coff_id,
    crs_off_inst_id: state => state.crs_off_inst_id,
   // commn_id: state => state.commn_id,
   
    //below 4 vars used for Homework added on 19-10-21
    course_off_id: state => state.course_off_id,
    coaid: state => state.coaid,
    ay_id: state => state.ay_id,
    div_off_id: state => state.div_off_id,
    coi_id: state => state.coi_id,
    homework_id: state => state.homework_id,
    vdo_files: state => state.vdo_files,
    child_data: state => state.child_data,
  }
});